<script>
    // https://stackoverflow.com/questions/34929095/chartjs-2-stacked-bar-and-unstacked-line-on-same-chart-with-same-y-axis

    import { Bar, mixins } from 'vue-chartjs';

    const { reactiveProp } = mixins;

    export default {
        extends: Bar,
        mixins: [reactiveProp],
        props: ['height', 'miny', 'maxy', 'changeyaxis'],
        data () {
            return {
                options: {
                    tooltips: {
                        mode: 'index'
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            boxWidth: 20,
                        },
                    },
                    scales: {
                        xAxes: [{
                            stacked: false,
                            categorySpacing: 0,
                            categoryPercentage: 0.8,
                            barPercentage: 0.8,
                            gridLines: {
                                drawOnChartArea: false,
                            },
                        }],
                        yAxes: [{
                            id: 'bar',
                            stacked: false,
                            ticks: {
                                beginAtZero: true,
                                min: this.miny,
                                max: this.maxy,
                                maxTicksLimit: 5,
                            },
                            gridLines: {
                                display: true,
                            },
                        },
                        {
                            id: 'line',
                            stacked: false,
                            display: false,
                            ticks: {
                                beginAtZero: true,
                                min: this.miny,
                                max: this.maxy, // beide assen moeten dezelde schaal!!
                                maxTicksLimit: 5,
                            },
                            gridLines: {
                                display: true,
                            },
                        },
                        ],
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3,
                        },
                    },
                },
            };
        },
        mounted () {
            // this.chartData is created in the mixin and
            // contains all the data needed to build the chart
            this.renderChart(this.chartData, this.options);
        },
        watch: {
            changeyaxis () {
                /* eslint no-underscore-dangle: ["error", { "allow": ["_chart"] }] */
                this.$data._chart.destroy();
                this.options.scales.yAxes[0].ticks.min = this.miny;
                this.options.scales.yAxes[1].ticks.min = this.miny;
                this.options.scales.yAxes[0].ticks.max = this.maxy;
                this.options.scales.yAxes[1].ticks.max = this.maxy;
                this.renderChart(this.chartData, this.options);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/licht/ChartNotStacked.vue